import { Action, ActionReducer } from '@ngrx/store';
import { IAppState } from '@shared/store/models';
import * as HydrationActions from './hydration.actions';

export function isHydrateSuccess(
  action: Action
): action is ReturnType<typeof HydrationActions.hydrateSuccess> {
  return action.type === HydrationActions.hydrateSuccess.type;
}

export const hydrationMetaReducer = (
  reducer: ActionReducer<IAppState>
): ActionReducer<IAppState> => {
  return (state, action) => {
    if (isHydrateSuccess(action)) {
      return {
        ...state,
        ...action.state,
      };
    } else {
      return reducer(state, action);
    }
  };
};
